<template>
  <Popup
    :title="title"
    btn-text="Удалить"
    :loading="loading"
    :disabled="disabled"
    @close="$emit('close')"
    @approve="$emit('approve')"
  >
    <p class="panel-delete-confirm">
      <span class="panel-delete-confirm__warning">
        Вы уверены, что хотите удалить {{ panelText }}?
      </span>
      <span class="panel-delete-confirm__description">
        При удалении панели будут удалены все связанные управляемые устройства и
        настройки доступа
      </span>
    </p>
  </Popup>
</template>

<script>
import Popup from '../../components/Popup.vue'

export default {
  name: 'PanelDeleteConfirm',
  components: { Popup },
  props: {
    panelCount: {
      type: Number,
      default: 1,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    title() {
      return this.panelCount > 1 ? 'Удалить панели' : 'Удалить панель'
    },
    panelText() {
      if (this.panelCount === 1) {
        return 'выбранную панель'
      } else if (this.panelCount < 5) {
        return `${this.panelCount} панели`
      } else {
        return `${this.panelCount} панелей`
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.panel-delete-confirm {
  display: flex;
  flex-direction: column;
  gap: 12px;

  &__warning {
    color: #000000;
    font-size: 16px;
    font-weight: 600;
  }

  &__description {
    color: $color-grey-3;
    font-size: 14px;
    line-height: 1.5;
  }
}
</style>
